function helperStringLowerCase (str) {
  return str.toLowerCase()
}

module.exports = helperStringLowerCase



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperStringLowerCase.js
// module id = c88F
// module chunks = 137